export const TEST_PROBE_TYPE = "TestProbeError";

// Thrown or reported by the test shortcuts and URL probes so the tracker can tag the event.
export class TestProbeError extends Error {
	constructor(message: string) {
		super(message);
		this.name = TEST_PROBE_TYPE;
	}
}
